<template>
  <div class="components-page-header border-B">
    <div class="logo-icon">
    </div>
    <!-- <div
      class="toggle-side-bar-btn"
      :class="{ close: !sideBarOpened }"
      @click="toggleOpenSidebar"
    >
      <i class="iconfont icon-cebianlan"></i>
    </div> -->
    <div class="breadcrumbFlex">
      <tagsView />
    </div>

    <div class="pull-right rightBox">
      <applicationsSwitchBar v-if="isLogined" />
      <userHeaderBar class="marginL30" />
    </div>
  </div>
</template>

<script>
import tagsView from '../tags-view';
import applicationsSwitchBar from './applications-switch-bar';
import userHeaderBar from './user-header-bar';
import { mapState } from 'vuex';

export default {
  name: 'page-header',
  components: {
    tagsView,
    applicationsSwitchBar,
    userHeaderBar
  },
  computed: {
    ...mapState({
      sideBarOpened: state => state.sideBarOpened
    }),
    isCollapse() {
      return !this.sideBarOpened;
    },
    isLogined() {
      return this.$store.state.user.isLogined;
    }
  },
  methods: {
    toggleOpenSidebar() {
      this.$store.commit('UPDATE_SIDEBAR_STATE', !this.sideBarOpened);
    },
  }
};
</script>

<style lang="scss" scoped>
.components-page-header {
  height: 48px;
  line-height: 48px;
  background: white;
  padding-left: $content-both-sides-padding;
  padding-right: $content-both-sides-padding;
  display: flex;
  align-items: center;
  .logo-icon {
    width: 170px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    margin-right: 20px;
    background: url('../../common/images/logo.svg');
    background-repeat: no-repeat;
    background-position: left center;
  }
}
.breadcrumbFlex {
  line-height: 40px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-x: auto;
  display: flex;
  align-items: center;
}
.rightBox {
  min-width: 358px;
  -webkit-box-flex: 0.5;
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: right;
}
.toggle-side-bar-btn {
  display: inline-block;
  cursor: pointer;
  width: 36px;
  height: 28px;
  line-height: 28px;
  color: white;
  text-align: center;
  background: $primary;
  border-radius: 4px;
  margin-right: 20px;
  vertical-align: middle;
  i {
    display: inline-block;
    transform: rotate(180deg);
    transition: all $transition-time;
  }
  &.close {
    i {
      transform: rotate(90deg);
    }
  }
}
</style>
